import { useEffect, useState } from 'react';

import {
	EMPTY_PAGE_CONTENT_RECT,
	getPageContentRect,
	isSamePageContentRect,
	subscribeToPageContentRect,
	type PageContentRect,
} from '../utils/pageContentDimensionsStore.ts';

export type PageContentDimensions = {
	width: number | string;
	left?: number;
	right?: number;
};

/**
 * Custom hook to track page-content-only dimensions for layout alignment and blue background sizing
 * @returns Object containing width, left, and right dimensions of the page-content-only element
 */
export const usePageContentDimensions = (): PageContentDimensions => {
	const [dimensions, setDimensions] = useState<PageContentRect>(EMPTY_PAGE_CONTENT_RECT);

	useEffect(() => {
		const publish = (rect: PageContentRect) =>
			setDimensions((current) => (isSamePageContentRect(current, rect) ? current : rect));

		// `ViewPageContent` registers the element with the store through a callback ref, so there is
		// nothing to look up in the DOM and no MutationObserver to keep armed. Every consumer of
		// this hook shares one ResizeObserver instead of creating its own pair of observers.
		publish(getPageContentRect());
		return subscribeToPageContentRect(publish);
	}, []);

	return dimensions;
};
